module.exports = __webpack_public_path__ + "static/media/htr3.3d3b8bc4.jpg";